import {
  getAccessToken,
  getLastWsDataByTabId,
  getTokenType,
} from "helpers/local_storage"

interface SavedWorkspaceData {
  wsCode: string
  token: string
}
function getTabId() {
  if (!window.name) {
    window.name = `tab-${Date.now()}-${Math.random().toString(36).substring(2)}`
  }
  return window.name
}

export const getAccessTokenInLocalStorage = () => {
  const token = getAccessToken()
  const tokenType = getTokenType() || "Bearer"
  const tabId = getTabId()
  const saved = getLastWsDataByTabId(tabId)
  if (!saved) return `${tokenType} ${token}`
  const data: SavedWorkspaceData = JSON.parse(saved)
  return `${tokenType} ${data.token}`
}
